<ngx-spinner name="upsSpinner" bdColor="rgba(255, 255, 255, 0.8)" size="medium" color="#321815" type="custom" [fullScreen]="true">
  <app-spinner></app-spinner>
</ngx-spinner>

@if (isLoading) {
  <div class="spinner-container">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}

<!-- Spinner and Dashboard Section -->
<div class="col-12">
  @if (!isLoader && !isDetailView) {
    <div class="card card-body mt-1-percent">
      <span class="list-title">Pending Request</span>
      <app-dynamictable
        [displayedColumns]="mainTableFieldMapping"
        [dataSource]="dataSource"
        (openDialog)="openAcceptOrRejectDialog($event)"
        [isFromBulkUpload]="true"
        [hideFilterAndRefresh]="true">
      </app-dynamictable>
    </div>
  }
  @if (!isLoader && isDetailView) {
    <div class="card card-body mt-1-percent">
      <div class="details-header mb-3">
        <button mat-flat-button class="custom-back-btn back-btn-colored" (click)="backToDashboard()" [disabled]="isLoading">
          ← Back
        </button>
        <div class="info">
          Please use this button to navigate back to the previous history screen
        </div>
      </div>
      <span class="list-title">Request Details</span>
      <app-dynamictable
        [displayedColumns]="detailTableFieldMapping"
        [dataSource]="invoiceDataSource"
        (openDialog)="openAcceptOrRejectDialog($event)"
        [isFromBulkUpload]="true"
        [hideFilterAndRefresh]="true">
      </app-dynamictable>
    </div>
  }
</div>

<div [class.loading-disabled]="isLoading">
  <ng-template #template1>
    <div class="modal-header">
      <h4 class="modal-title centered-title">Accept/Reject Adjustments</h4>
      <button type="button" class="btn btn-warning btn-lg close-btn" aria-label="Close" (click)="closePopup1()" [disabled]="isLoading">
        <i class="fas fa-window-close"></i>
      </button>
    </div>

    <div class="card card-body card-padding">
      <mat-card class="result">
        <mat-card-content>
          <div class="button-container">

            <!-- Accept Button -->
            <button type="button"
              class="btn btn-yellow mt-4 d-flex align-items-center px-3 py-2 decision-btn"
              [ngClass]="{ 'active-accept': isAccepted() === 'accept' }"
              (click)="isAccepted.set('accept')"
              [disabled]="isLoading">
              <mat-icon class="icon-green">check</mat-icon>
              <span>Accept</span>
            </button>

            <!-- Reject Button -->
            <button type="button"
              class="btn btn-yellow mt-4 d-flex align-items-center px-3 py-2 decision-btn"
              [ngClass]="{ 'active-reject': isAccepted() === 'reject' }"
              (click)="isAccepted.set('reject')"
              [disabled]="isLoading">
              <mat-icon class="icon-red">close</mat-icon>
              <span>Reject</span>
            </button>

            <!-- Need More Info Button -->
            <button type="button"
              class="btn btn-yellow mt-4 d-flex align-items-center px-3 py-2 decision-btn need-more-btn"
              [ngClass]="{ 'active-need-info': isAccepted() === 'needMoreInfo' }"
              (click)="isAccepted.set('needMoreInfo')"
              [disabled]="isLoading">
              <mat-icon class="icon-blue">info</mat-icon>
              <span class="text-truncate">Need More Info</span>
            </button>

          </div>

          <form [formGroup]="firstFormGroup">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label class="fs-13">Reason/Comments</mat-label>
              <textarea matInput formControlName="reason" class="fs-12 light-placeholder"
              placeholder="Enter your Comments here" [required]="isAccepted() === 'needMoreInfo' || isAccepted() === 'reject'" [disabled]="isLoading"></textarea>
              @if (firstFormGroup.controls['reason'].invalid && (firstFormGroup.controls['reason'].touched || firstFormGroup.controls['reason'].dirty)) {
                <mat-error class="fs-14"
                  >
                  @if (firstFormGroup.controls['reason'].errors?.['required']) {
                    <span>Reason/Comment required</span>
                  }
                  @if (firstFormGroup.controls['reason'].errors?.['maxlength']) {
                    <span>Reason/Comment cannot exceed 1000 characters</span>
                  }
                  @if (firstFormGroup.controls['reason'].errors?.['pattern']) {
                    <span>Enter the valid Reason/Comment</span>
                  }
                </mat-error>
              }
            </mat-form-field>
          </form>

          <div class="button-container">
            <button [disabled]="isLoading" type="button" class="btn-upsbrown-default mt-4" (click)="onNext()">
              @if (isLoading) {
                <span class="loader"></span>
              }
              @if (!isLoading) {
                <span>Submit</span>
              }
            </button>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </ng-template>
</div>
